"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcceptFormTextField = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var react_1 = __importDefault(require("react"));
var styles = __importStar(require("./TextField.css"));
var classnames_1 = __importDefault(require("classnames"));
var AcceptFormTextField = function (_a) {
    var isPrintMode = _a.isPrintMode, props = __rest(_a, ["isPrintMode"]);
    if (isPrintMode) {
        return (react_1.default.createElement(kaleidoscope_1.Stack, { className: (0, classnames_1.default)(styles.printableSlot, "accept-form-printable-field") },
            react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.fieldGrid },
                react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.fieldBorder },
                    react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.fieldContent })),
                react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.fieldLabelContainer, direction: "horizontal", justify: "spaceBetween" },
                    react_1.default.createElement(kaleidoscope_1.Text, { className: styles.fieldLabel, strong: true }, props.label)))));
    }
    return react_1.default.createElement(kaleidoscope_1.FormTextInput, __assign({}, props));
};
exports.AcceptFormTextField = AcceptFormTextField;
